import React from 'react'
import Footer from '../components/footerComponent/footer'
import EditGroup from '../components/teacherComponent/editGroupComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function EditGroupPage() {
    return (
        <Layout>
            <Header/>
            <EditGroup/>
            <Footer/>
        </Layout>
    );
};